module.exports = __webpack_public_path__ + "img/kempin.28d0a4cd.png";